import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Megaphone, X } from 'lucide-react';
import { Link } from 'react-router-dom';

// Inline in-app push banner. Polls every 30s and shows the most recent
// unread announcement at the top of the client dashboard.
export default function AnnouncementsBanner() {
  const [a, setA] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get('/announcements/mine');
      const unread = (data || []).find((x) => !x.read_at);
      setA(unread || null);
    } catch {}
  };
  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, []);

  const dismiss = async () => {
    if (!a) return;
    try { await api.post('/announcements/mark-read', { announcement_id: a.id }); } catch {}
    setA(null);
  };

  if (!a) return null;
  const cta = a.cta_label && a.cta_url;
  const isExternal = cta && /^https?:/.test(a.cta_url);
  return (
    <Card className='relative overflow-hidden border border-[#C8102E]/30 bg-gradient-to-r from-[#1B3A87] to-[#16306F] text-white mb-5' data-testid='announcement-banner'>
      <button onClick={dismiss} className='absolute top-2 right-2 text-white/80 hover:text-white p-1' aria-label='Dismiss' data-testid='announcement-dismiss'>
        <X className='w-4 h-4' />
      </button>
      <div className='p-4 sm:p-5 flex flex-col sm:flex-row items-start gap-3 sm:items-center sm:gap-4'>
        <div className='w-10 h-10 rounded-md bg-white/15 flex items-center justify-center shrink-0'>
          <Megaphone className='w-5 h-5' />
        </div>
        <div className='flex-1 min-w-0'>
          <div className='text-[10px] uppercase tracking-[0.18em] font-bold text-[#FECDD3]'>JFK9 Announcement</div>
          <div className='font-display font-bold text-base sm:text-lg mt-0.5'>{a.title}</div>
          <div className='text-sm text-white/90 mt-1 whitespace-pre-wrap line-clamp-3'>{a.body}</div>
        </div>
        {cta && (
          isExternal ? (
            <a href={a.cta_url} target='_blank' rel='noopener noreferrer' className='px-4 py-2 rounded-md bg-[#C8102E] hover:bg-[#A50D26] text-sm font-semibold shrink-0' data-testid='announcement-cta'>{a.cta_label}</a>
          ) : (
            <Link to={a.cta_url} className='px-4 py-2 rounded-md bg-[#C8102E] hover:bg-[#A50D26] text-sm font-semibold shrink-0' data-testid='announcement-cta' onClick={() => api.post('/announcements/mark-read', { announcement_id: a.id }).catch(()=>{})}>
              {a.cta_label}
            </Link>
          )
        )}
      </div>
    </Card>
  );
}
